// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import { loadProgressBar } from 'axios-progress-bar'
import Vuelidate from 'vuelidate'
import App from './App'
import router from './router'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)
Vue.use(Vuelidate)
Vue.use(loadProgressBar)
Vue.use(BootstrapVue)

axios.defaults.withCredentials = true

Vue.prototype.$http = axios

Vue.prototype.API_ENDPOINT = (process.env.NODE_ENV !== 'production') ? process.env.API_ENDPOINT : 'agent-panel'
Vue.prototype.CURRENCY = (process.env.NODE_ENV !== 'production') ? process.env.CURRENCY : ''

Vue.prototype.SETTING = {
  product: process.env.PRODUCT,
  system: process.env.SYSTEM,
  logo: process.env.LOGO
}

router.beforeEach((to, from, next) => {
  axios.post(Vue.prototype.API_ENDPOINT + '/api/v1/agent/checkLogin', {headers: { 'Content-Type': 'application/json' }}).then(response => {
    if (response.data.user === null) {
      if (to.path !== '/login') {
        next('/login')
        return
      }
      next()
    } else {
      Vue.prototype.ACCOUNT_TYPE = response.data.user.accountType
      window.sessionStorage.setItem('client', JSON.stringify(response.data.user))
      next()
    }
  }).catch(err => {
    console.log('this is an error ', err)
  })
})

axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  console.log(error)
  // Do something with response error
  if (error.response.status === 401 && window.location.hash !== '#/login') {
    window.location.href = '/'
  }
  return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App v-if="!fetching"/>',
  components: {
    App
  },
  data: {
    fetching: true
  },
  methods: {
    async getSiteConfig () {
      let { data } = await this.$http.get('/getSiteConfig', { headers: { 'Content-Type': 'application/json' } })
      Vue.prototype.CURRENCY = data.CURRENCY
      Vue.prototype.SETTING = {
        product: data.PRODUCT,
        system: data.SYSTEM,
        logo: data.LOGO,
        currency: data.CURRENCY
      }
    },
    async checkLogin () {
      try {
        let { data } = await this.$http.post(Vue.prototype.API_ENDPOINT + '/api/v1/agent/checkLogin', {headers: { 'Content-Type': 'application/json' }})
        return data
      } catch (err) {
        console.log(err)
        throw err
      }
    }
  },
  async created () {
    try {
      this.fetching = true
      if (process.env.NODE_ENV === 'production') {
        await this.getSiteConfig()
      }
      await this.checkLogin()
    } catch (err) {
      console.log(err)
    } finally {
      this.fetching = false
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js